/** Card chrome shared by every EntityCard variant (background, border, radius). */
export const cardBase = "bg-background-primary border border-overlay-medium rounded-sm flex";
